import { B2bAdminShow } from '@sh4res/bo-common/components/B2bAdmins/B2bAdminShow';

import { GhostLinkField } from '@Resources/admins/GhostLinkField';
import { ResourceDefinition } from '@Utils/types';

export const adminsResource: ResourceDefinition = {
  options: { label: 'menu.admins' },
  show: (props) => (
    <B2bAdminShow
      ghostLinkComponent={
        <GhostLinkField label={false} data-testid={'BoExternalAdmins_GhostLinkField'} />
      }
      {...props}
    />
  ),
};
